import * as axios from 'axios';
import { API } from './config';
import querystring from 'querystring';
//import qs from 'qs';

var accessToken = null;
var refreshToken = null;
var isAuthorized = false;
var isAdmin = false;

const callRequest = async function(request){
  try{ 
    //debugger; // eslint-disable-line no-debugger
    const response = await axios(request);    
    return response;    
  }
  catch(error)
  {
    if(error.response.status == 401 && accessToken && refreshToken)
    {
      var tokens = await refreshAccessToken();
      request.headers["Authorization"] = "Bearer " + tokens.accessToken;
      return await callRequest(request);
    }
    else
    {
      throw error;     
    }    
  }
};

const getSampleData = async function(sampleId, folderId) {
    if(!isAuthorized)
    {                           
        return {};
    }
    if(accessToken == null)
    {
        console.log("something worng with credentials");
        return {};        
    } 
    const request = {
      url : API + `/api/samples/${folderId}/${sampleId}`,
      headers: {"Authorization" : "Bearer " + accessToken}
    };
    let response = null;  
    try{ 
      response = await callRequest(request);

    }
    catch(error)
    {
      console.log('error to get sample data.Retried.');
    }
    if(response.status != 200)
    {
        console.log('error to get sample data');
        return {};
    }
    var sample = response.data;
    if(sample)
      sample.saved = true;
    return sample;
};

const getSamples = async function(folderId) {
  if(!isAuthorized)
    {                           
        return [];
    }
    if(accessToken == null)
    {
        console.log("something worng with credentials");
        return [];        
    }   
    const request = {
      url : API + `/api/samples/${folderId}` ,
      headers: {"Authorization" : "Bearer " + accessToken}
    } 
    let response = undefined;
    try{
      response = await callRequest(request);
    }
    catch(error)
    {
      console.log('error to get samples data.Retried.');
    }
   
    if(response.status != 200)
    {
        console.log('error to get samples data');
        return {};
    }
    var samples = response.data;
    if(samples && samples.length> 0)
    {
      samples.forEach(element => {
        element.saved = true;
      });
    }
    return samples;
};

const addSample = async function(sample){
  if(!isAuthorized)
  {                           
      return sample;
  }
  if(accessToken == null)
  {
      console.log("something worng with credentials");
      return sample;        
  }  
  const request = {
      method: "post",
      url: API + "/api/samples?folderId=" + sample.folderId,
      headers: { 
        "Content-Type" : "application/json", 
        "Authorization" : "Bearer " + accessToken
    },        
    data: JSON.stringify(sample)
  };
  let response = undefined;
  try{
    response = await callRequest(request);   
  }
  catch(error)
  {
    console.log('error to save sample data.Retried');
    throw error;
  }
  
  if(response.status != 200)
  {
    console.log('error to save sample data');
    return sample;
  }

  var responseSample = response.data;
  responseSample.saved = true;
  return responseSample;
};

const updateSample = async function(sample){
  
  return await addSample(sample);
};

const deleteSample = async function(sampleId, folderId){

  if(!isAuthorized)
  {                           
      return;
  }
  if(accessToken == null)
  {
      console.log("something worng with credentials");
      return null;        
  }    
  var request =  {
        method: "DELETE",
        url: API + `/api/samples/${folderId}/${sampleId}`,
        headers: { 
          "Content-Type" : "application/json", 
          "Authorization" : "Bearer " + accessToken
      },       
      
    };
  let response = undefined;
  try{    
    response = await callRequest(request);
    if(response.status == 401)
    {

      console.log('error to delete sample. Unauthorized');
      return null;
    }
  }
  catch(error)
  {
      console.log('error to save delete sampple. Retried.');
  }
  if(response.status != 200)
  {
    console.log('error to delete sample');
    return null;
  }
  return response.data;
};

const getUsers = async function(){
  if(!isAuthorized)
  {   
    return;
  }
  const request = {
    url : API + '/api/users' ,
    headers: {"Authorization" : "Bearer " + accessToken}
  } 
  let response = undefined;
  try{
    response = await callRequest(request);
  }
  catch(error)
  {
    console.log('error to get users data.Retried.');
  }
  if(response.status != 200)
  {
      console.log('error to get users');
      return [];
  }

  return response.data;
};

const registerUser = async function(user){
  if(!isAuthorized)
  {                           
      return null;
  }
  const request = {
    method: "post",
    url: API + "/api/users",
    headers: { 
      "Content-Type" : "application/json", 
      "Authorization" : "Bearer " + accessToken
        },        
    data: JSON.stringify(user)
  };
  let response = undefined;
  try{
    response = await callRequest(request);   
  }
  catch(error)
  {
    console.log('error to save user data.Retried');
    return null;
  }
  if(response.status != 200)
  {
    console.log('error to save user data');
    return null;
  }
  return response.data;
};

const createFolder = async function(folderName)
{
  if(!isAuthorized)
  {                           
      return null;
  }
  const request = {
    method: "post",
    url: API + "/api/folders/" + folderName,
    headers: { 
      "Content-Type" : "application/json", 
      "Authorization" : "Bearer " + accessToken
        },        
  };
  let response = undefined;
  try{
    response = await callRequest(request);   
  }
  catch(error)
  {
    console.log('error to create folder');
    throw error;
  }
  if(response.status != 200)
  {
    console.log('error to save folder');
    return null;
  }
  return response.data;
};

const calculateSTC = async function(measuredData)
{
  if(!isAuthorized)
  {                           
      return null;
  }
  const request = {
    method: "post",
    url: API + "/api/Calculators/stc",
    headers: { 
      "Content-Type" : "application/json", 
      "Authorization" : "Bearer " + accessToken
        },      
    data: JSON.stringify(measuredData)  
  };
  let response = undefined;
  try{
    response = await callRequest(request);   
  }
  catch(error)
  {
    console.log('error to calculateSTC');
    throw error;
  }
  if(response.status != 200)
  {
    console.log('error to calculateSTC. wrong status code');
    return null;
  }
  return response.data;
};

const getUserFolders = async function(){
  if(!isAuthorized)
  {   
    return;
  }
  const request = {
    url : API + '/api/folders' ,
    headers: {"Authorization" : "Bearer " + accessToken}
  } 
  let response = undefined;
  try{
    response = await callRequest(request);
  }
  catch(error)
  {
    console.log('error to get user folders');
  }
  if(response.status != 200)
  {
      console.log('error to get folders');
      return [];
  }

  return response.data;
};

const deleteToken = function(){
  clearTokens();
};

const refreshAccessToken = async function(){
  if(!accessToken || !refreshToken)
  {   
    return;
  }
  const request = {
    method: "post",
    url: API + "/api/account/refreshtoken",
    headers: { 
      "Content-Type" : "application/json"       
      },        
    data: JSON.stringify({accessToken,refreshToken})
  };
  let response = undefined;
  try{
    response = await axios(request);   
  }
  catch(error)
  {
    console.log('error to get new access token');
    clearTokens();  
    return null;
  }

  if(response.status == 200)
  {
      accessToken = response.data.access_token;
      refreshToken = response.data.refresh_token;
      isAdmin = response.data.isAdmin;
      isAuthorized = true;
  }
  else
  {
      clearTokens();  
  }
  return { accessToken, refreshToken } ;
};


const getTokens = async function(username,password){  
    const response = await axios(
        {
            method: "post",
            url: API + "/api/account/token",
            headers: { 
              "Content-Type" : "application/x-www-form-urlencoded", 
           },
            //withCredentials: true,            
            data:  //`grant_type=password&username=${username.replace("@","%40")}&password=${password}`
                querystring.stringify(
                {
                    "grant_type": "password",
                    "username" : username,
                    "password" : password
                })
        }
    );
    console.log(response);
    if(response.status == 200)
    {
        accessToken = response.data.access_token;
        refreshToken = response.data.refresh_token;
        isAdmin = response.data.isAdmin;
        isAuthorized = true;
    }
    else
    {
      clearTokens();   
      throw 'token was not refreshed';     
    }
    return { accessToken, refreshToken } ;
  
};

const clearTokens = function(){
  accessToken = null;
  refreshToken = null;
  isAdmin = false;
  isAuthorized = false;
};

const isUserAdmin = function(){
  return isAdmin;
};

const getDataExample = function () {

    const sample = 
        [
            {
              "x": 34477,
              "y": 13
            },
            {
              "x": 34481,
              "y": 10
            },
            {
              "x": 34481,
              "y": 11
            },
            {
              "x": 34477,
              "y": 11
            },
            {
              "x": 34477,
              "y": 8
            },
            {
              "x": 34477,
              "y": 10
            },
            {
              "x": 34477,
              "y": 11
            },
            {
              "x": 34481,
              "y": 10
            },
            {
              "x": 34477,
              "y": 10
            },
            {
              "x": 34477,
              "y": 11
            },
            {
              "x": 34477,
              "y": 10
            },
            {
              "x": 34477,
              "y": 13
            },
            {
              "x": 34477,
              "y": 11
            },
            {
              "x": 34477,
              "y": 13
            },
            {
              "x": 34477,
              "y": 13
            },
            {
              "x": 34477,
              "y": 11
            },
            {
              "x": 34477,
              "y": 14
            },
            {
              "x": 34477,
              "y": 14
            },
            {
              "x": 34477,
              "y": 11
            },
            {
              "x": 34477,
              "y": 13
            },
            {
              "x": 34477,
              "y": 14
            },
            {
              "x": 34477,
              "y": 14
            },
            {
              "x": 34477,
              "y": 14
            },
            {
              "x": 34477,
              "y": 14
            },
            {
              "x": 34477,
              "y": 10
            },
            {
              "x": 34477,
              "y": 14
            },
            {
              "x": 34477,
              "y": 11
            },
            {
              "x": 34477,
              "y": 14
            },
            {
              "x": 34477,
              "y": 13
            },
            {
              "x": 34477,
              "y": 16
            },
            {
              "x": 34477,
              "y": 13
            },
            {
              "x": 34477,
              "y": 17
            },
            {
              "x": 34477,
              "y": 17
            },
            {
              "x": 34473,
              "y": 16
            },
            {
              "x": 34473,
              "y": 17
            },
            {
              "x": 34477,
              "y": 18
            },
            {
              "x": 34473,
              "y": 18
            },
            {
              "x": 34477,
              "y": 17
            },
            {
              "x": 34473,
              "y": 17
            },
            {
              "x": 34473,
              "y": 17
            },
            {
              "x": 34473,
              "y": 20
            },
            {
              "x": 34473,
              "y": 22
            },
            {
              "x": 34473,
              "y": 27
            },
            {
              "x": 34470,
              "y": 20
            },
            {
              "x": 34473,
              "y": 21
            },
            {
              "x": 34473,
              "y": 20
            },
            {
              "x": 34470,
              "y": 27
            },
            {
              "x": 34470,
              "y": 28
            },
            {
              "x": 34470,
              "y": 30
            },
            {
              "x": 34470,
              "y": 30
            },
            {
              "x": 34470,
              "y": 25
            },
            {
              "x": 34470,
              "y": 31
            },
            {
              "x": 34470,
              "y": 28
            },
            {
              "x": 34470,
              "y": 33
            },
            {
              "x": 34470,
              "y": 37
            },
            {
              "x": 34466,
              "y": 31
            },
            {
              "x": 34466,
              "y": 36
            },
            {
              "x": 34466,
              "y": 37
            },
            {
              "x": 34462,
              "y": 40
            },
            {
              "x": 34466,
              "y": 41
            },
            {
              "x": 34462,
              "y": 44
            },
            {
              "x": 34462,
              "y": 43
            },
            {
              "x": 34458,
              "y": 45
            },
            {
              "x": 34458,
              "y": 48
            },
            {
              "x": 34458,
              "y": 51
            },
            {
              "x": 34455,
              "y": 56
            },
            {
              "x": 34455,
              "y": 54
            },
            {
              "x": 34455,
              "y": 60
            },
            {
              "x": 34455,
              "y": 61
            },
            {
              "x": 34451,
              "y": 63
            },
            {
              "x": 34451,
              "y": 65
            },
            {
              "x": 34447,
              "y": 67
            },
            {
              "x": 34451,
              "y": 70
            },
            {
              "x": 34447,
              "y": 79
            },
            {
              "x": 34443,
              "y": 77
            },
            {
              "x": 34447,
              "y": 86
            },
            {
              "x": 34440,
              "y": 87
            },
            {
              "x": 34440,
              "y": 90
            },
            {
              "x": 34440,
              "y": 96
            },
            {
              "x": 34436,
              "y": 97
            },
            {
              "x": 34432,
              "y": 102
            },
            {
              "x": 34432,
              "y": 108
            },
            {
              "x": 34428,
              "y": 111
            },
            {
              "x": 34428,
              "y": 114
            },
            {
              "x": 34425,
              "y": 122
            },
            {
              "x": 34421,
              "y": 126
            },
            {
              "x": 34421,
              "y": 127
            },
            {
              "x": 34417,
              "y": 131
            },
            {
              "x": 34413,
              "y": 140
            },
            {
              "x": 34410,
              "y": 147
            },
            {
              "x": 34410,
              "y": 153
            },
            {
              "x": 34406,
              "y": 159
            },
            {
              "x": 34402,
              "y": 163
            },
            {
              "x": 34398,
              "y": 173
            },
            {
              "x": 34395,
              "y": 182
            },
            {
              "x": 34391,
              "y": 185
            },
            {
              "x": 34387,
              "y": 189
            },
            {
              "x": 34383,
              "y": 196
            },
            {
              "x": 34380,
              "y": 208
            },
            {
              "x": 34380,
              "y": 215
            },
            {
              "x": 34372,
              "y": 220
            },
            {
              "x": 34368,
              "y": 231
            },
            {
              "x": 34365,
              "y": 242
            },
            {
              "x": 34357,
              "y": 252
            },
            {
              "x": 34353,
              "y": 262
            },
            {
              "x": 34350,
              "y": 268
            },
            {
              "x": 34346,
              "y": 276
            },
            {
              "x": 34342,
              "y": 291
            },
            {
              "x": 34335,
              "y": 301
            },
            {
              "x": 34327,
              "y": 305
            },
            {
              "x": 34323,
              "y": 318
            },
            {
              "x": 34316,
              "y": 329
            },
            {
              "x": 34312,
              "y": 342
            },
            {
              "x": 34305,
              "y": 355
            },
            {
              "x": 34301,
              "y": 365
            },
            {
              "x": 34293,
              "y": 380
            },
            {
              "x": 34282,
              "y": 389
            },
            {
              "x": 34278,
              "y": 404
            },
            {
              "x": 34271,
              "y": 417
            },
            {
              "x": 34263,
              "y": 432
            },
            {
              "x": 34256,
              "y": 451
            },
            {
              "x": 34248,
              "y": 463
            },
            {
              "x": 34241,
              "y": 475
            },
            {
              "x": 34233,
              "y": 490
            },
            {
              "x": 34226,
              "y": 509
            },
            {
              "x": 34215,
              "y": 524
            },
            {
              "x": 34207,
              "y": 537
            },
            {
              "x": 34200,
              "y": 561
            },
            {
              "x": 34192,
              "y": 577
            },
            {
              "x": 34185,
              "y": 593
            },
            {
              "x": 34173,
              "y": 609
            },
            {
              "x": 34162,
              "y": 627
            },
            {
              "x": 34151,
              "y": 646
            },
            {
              "x": 34140,
              "y": 667
            },
            {
              "x": 34132,
              "y": 686
            },
            {
              "x": 34121,
              "y": 704
            },
            {
              "x": 34110,
              "y": 728
            },
            {
              "x": 34098,
              "y": 745
            },
            {
              "x": 34087,
              "y": 768
            },
            {
              "x": 34072,
              "y": 792
            },
            {
              "x": 34061,
              "y": 815
            },
            {
              "x": 34050,
              "y": 841
            },
            {
              "x": 34035,
              "y": 865
            },
            {
              "x": 34023,
              "y": 888
            },
            {
              "x": 34008,
              "y": 913
            },
            {
              "x": 33993,
              "y": 939
            },
            {
              "x": 33986,
              "y": 964
            },
            {
              "x": 33967,
              "y": 991
            },
            {
              "x": 33948,
              "y": 1020
            },
            {
              "x": 33937,
              "y": 1052
            },
            {
              "x": 33926,
              "y": 1073
            },
            {
              "x": 33907,
              "y": 1106
            },
            {
              "x": 33888,
              "y": 1138
            },
            {
              "x": 33873,
              "y": 1165
            },
            {
              "x": 33855,
              "y": 1198
            },
            {
              "x": 33840,
              "y": 1231
            },
            {
              "x": 33821,
              "y": 1260
            },
            {
              "x": 33802,
              "y": 1292
            },
            {
              "x": 33783,
              "y": 1328
            },
            {
              "x": 33765,
              "y": 1361
            },
            {
              "x": 33746,
              "y": 1396
            },
            {
              "x": 33723,
              "y": 1440
            },
            {
              "x": 33705,
              "y": 1473
            },
            {
              "x": 33682,
              "y": 1512
            },
            {
              "x": 33660,
              "y": 1555
            },
            {
              "x": 33633,
              "y": 1585
            },
            {
              "x": 33611,
              "y": 1632
            },
            {
              "x": 33588,
              "y": 1672
            },
            {
              "x": 33566,
              "y": 1715
            },
            {
              "x": 33540,
              "y": 1757
            },
            {
              "x": 33513,
              "y": 1800
            },
            {
              "x": 33491,
              "y": 1847
            },
            {
              "x": 33465,
              "y": 1894
            },
            {
              "x": 33435,
              "y": 1936
            },
            {
              "x": 33408,
              "y": 1994
            },
            {
              "x": 33375,
              "y": 2041
            },
            {
              "x": 33348,
              "y": 2088
            },
            {
              "x": 33318,
              "y": 2141
            },
            {
              "x": 33285,
              "y": 2203
            },
            {
              "x": 33251,
              "y": 2246
            },
            {
              "x": 33217,
              "y": 2312
            },
            {
              "x": 33183,
              "y": 2363
            },
            {
              "x": 33146,
              "y": 2426
            },
            {
              "x": 33108,
              "y": 2484
            },
            {
              "x": 33067,
              "y": 2544
            },
            {
              "x": 33030,
              "y": 2610
            },
            {
              "x": 32988,
              "y": 2677
            },
            {
              "x": 32947,
              "y": 2742
            },
            {
              "x": 32906,
              "y": 2808
            },
            {
              "x": 32857,
              "y": 2879
            },
            {
              "x": 32812,
              "y": 2954
            },
            {
              "x": 32763,
              "y": 3020
            },
            {
              "x": 32718,
              "y": 3101
            },
            {
              "x": 32662,
              "y": 3182
            },
            {
              "x": 32610,
              "y": 3259
            },
            {
              "x": 32557,
              "y": 3344
            },
            {
              "x": 32493,
              "y": 3424
            },
            {
              "x": 32433,
              "y": 3513
            },
            {
              "x": 32373,
              "y": 3599
            },
            {
              "x": 32306,
              "y": 3699
            },
            {
              "x": 32238,
              "y": 3786
            },
            {
              "x": 32163,
              "y": 3891
            },
            {
              "x": 32088,
              "y": 4001
            },
            {
              "x": 32010,
              "y": 4106
            },
            {
              "x": 31923,
              "y": 4207
            },
            {
              "x": 31837,
              "y": 4318
            },
            {
              "x": 31751,
              "y": 4426
            },
            {
              "x": 31657,
              "y": 4539
            },
            {
              "x": 31560,
              "y": 4649
            },
            {
              "x": 31455,
              "y": 4778
            },
            {
              "x": 31346,
              "y": 4904
            },
            {
              "x": 31230,
              "y": 5026
            },
            {
              "x": 31110,
              "y": 5157
            },
            {
              "x": 30978,
              "y": 5291
            },
            {
              "x": 30840,
              "y": 5438
            },
            {
              "x": 30693,
              "y": 5571
            },
            {
              "x": 30532,
              "y": 5706
            },
            {
              "x": 30363,
              "y": 5869
            },
            {
              "x": 30180,
              "y": 6021
            },
            {
              "x": 29977,
              "y": 6182
            },
            {
              "x": 29763,
              "y": 6326
            },
            {
              "x": 29523,
              "y": 6486
            },
            {
              "x": 29253,
              "y": 6653
            },
            {
              "x": 28957,
              "y": 6819
            },
            {
              "x": 28627,
              "y": 6980
            },
            {
              "x": 28248,
              "y": 7123
            },
            {
              "x": 27810,
              "y": 7291
            },
            {
              "x": 27292,
              "y": 7441
            },
            {
              "x": 26651,
              "y": 7578
            },
            {
              "x": 25822,
              "y": 7682
            },
            {
              "x": 24720,
              "y": 7784
            },
            {
              "x": 23216,
              "y": 7840
            },
            {
              "x": 21285,
              "y": 7854
            },
            {
              "x": 19533,
              "y": 7859
            },
            {
              "x": 18018,
              "y": 7866
            },
            {
              "x": 16770,
              "y": 7867
            },
            {
              "x": 15592,
              "y": 7876
            },
            {
              "x": 14565,
              "y": 7879
            },
            {
              "x": 13552,
              "y": 7877
            },
            {
              "x": 12701,
              "y": 7883
            },
            {
              "x": 11861,
              "y": 7885
            },
            {
              "x": 11122,
              "y": 7885
            },
            {
              "x": 10365,
              "y": 7886
            },
            {
              "x": 9697,
              "y": 7886
            },
            {
              "x": 9056,
              "y": 7887
            },
            {
              "x": 8512,
              "y": 7886
            },
            {
              "x": 7995,
              "y": 7891
            },
            {
              "x": 7522,
              "y": 7889
            },
            {
              "x": 7046,
              "y": 7889
            },
            {
              "x": 6637,
              "y": 7893
            },
            {
              "x": 6255,
              "y": 7894
            },
            {
              "x": 5921,
              "y": 7896
            },
            {
              "x": 5617,
              "y": 7903
            },
            {
              "x": 5343,
              "y": 7900
            },
            {
              "x": 5088,
              "y": 7903
            },
            {
              "x": 4878,
              "y": 7900
            },
            {
              "x": 0,
              "y": 7922
            }
          ]
      ;

    return sample;
};

const getTesterData = function(){
  const data = this.getDataExample();
   
    const testerData = [];
    for(var i = 0; i< data.length; i++)
    {
      const tData = {position: i, i:data[i].y, u:data[i].x};
      testerData.push(tData);
    }
    return testerData;
};

export const dataService = { 
  
  getSampleData,
  getSamples,
  addSample,
  updateSample,  
  deleteSample,
  
  //remove
  getDataExample,  
  getTesterData,
  getTokens,
  deleteToken,

  getUsers,
  registerUser,
  isUserAdmin,

  createFolder,
  getUserFolders,
  calculateSTC
}